import React from 'react'
import AwardCard from './awardcard'
import './awards.css'

// Keep the archive independent of the reusable paginated view and its controls.
const AwardsArchive = ({ data = [] }) => (
  <div className="AwardDisplayArea AwardsArchive">
    <div className="AwardPages">
      <div className="AwardCardGroup">
        {data.length ? data.map(({ node }) => (
          <AwardCard
            key={node.id}
            balancedTitle
            sizes="(max-width: 640px) calc(55vw - 23px), (min-width: 1637px) 500px, 31vw"
            name={node.name}
            prize={node.prize}
            time={node.time}
            certificate={node.certificate.fluid.src}
          />
        )) : <p className="AwardsEmpty">暂时没有奖状记录。</p>}
      </div>
    </div>
  </div>
)

export default AwardsArchive
